import { render, staticRenderFns } from "./BookingListPage.vue?vue&type=template&id=4ce994a0&"
import script from "./BookingListPage.vue?vue&type=script&lang=js&"
export * from "./BookingListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports